import React, { useEffect, useState, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useReactFlow } from "reactflow";
import style from "./guideNodePage.module.css";
import func from "@uikit/func";
import { editorActions } from "../../../store/editor";
import { fotActions } from "../../../store/fot";
import { motion } from "framer-motion";
import { logEvent } from "@uikit/service/amplitude";
import { settings } from "imagica-corekit/dist/base/kernel/Settings";

const variants = {
  open: { opacity: 1, scale: 1, transition: { duration: 0.3 } },
  closed: { opacity: 0, scale: 0.8, transition: { duration: 0.3 } },
};
const length = 9;

const GuideNodePage = props => {
  const dispatch = useDispatch();
  const { setCenter, fitView } = useReactFlow();
  // const imagicaStudioTutorial = useSelector((state) => state.fot.imagicaStudioTutorial);
  // const setImagicaStudioTutorial = (val) => { dispatch(fotActions.setImagicaStudioTutorial(val)) };
  const stepVariableData = useSelector(state => state.fot.stepVariableData);

  const tutorialTempProjectData = useSelector(state => state.editor.tutorialTempProjectData);
  const tutorialSessionId = useSelector(state => state.fot.tutorialSessionId);
  const setTutorialSessionId = val => {
    dispatch(fotActions.setTutorialSessionId(val));
  };

  const setCurrentGuideTitlePage = val => {
    dispatch(editorActions.setCurrentGuideTitlePage(val));
  };

  // 关闭引导页
  const closeGuide = () => {
    setCurrentGuideTitlePage("exit");
  };
  const clickNextBtn = () => {
    props.clickStep(props.step + 1, setCenter);
  };
  const substitutionDescription = () => {
    let descriptionText = props?.hint?.description || "";
    // 变量替换
    if (!func.isEmpty(stepVariableData)) {
      for (let i in stepVariableData) {
        descriptionText = props.hint.description.replaceAll(i, stepVariableData[i]);
      }
    }
    return descriptionText;
  };

  if (func.isEmpty(props?.hint)) {
    return null;
  }
  return (
    <div className={props.step === 0 ? style["isLoading"] : ""}>
      <div className={`${style["triangle"]} triangle-${props.hint?.arrowPointing}`}></div>
      <div className={style["header-box"]}>
        <div className={style["step-title"]}>{`Step ${props.step} of ${length}`}</div>
        <div className={style["delete-content"]} onClick={() => closeGuide(props.step)}>
          <img src={`${settings.S3CDN}${settings.viewAssetsPath}ACAEB5Cross.svg`}></img>
        </div>
      </div>

      {!func.isEmpty(props.hint?.img_url) ? (
        <div className={style["picture-guide"]}>
          <img src={props.hint.img_url} width="250px" height="140px" alt="" />
        </div>
      ) : null}

      <div className={style["text-description"]}>
        <div className={style["description-title"]}>{props.hint.title}</div>
        <div className={style["description-content"]}>
          {Array.isArray(props.hint.description)
            ? props.hint.description.map((x, idx) => {
                if (props.highlightStrs?.includes(x)) {
                  return (
                    <span key={idx} className={style["description-highlight"]}>
                      {" "}
                      {x}{" "}
                    </span>
                  );
                }
                return x;
              })
            : substitutionDescription()}
        </div>
      </div>

      {props.step !== 0 ? (
        <div className={style["bottom-box"]}>
          {/* <div className={style["back-button"]} onClick={() => props.clickStep(props.step - 1)}> */}
          {/* <div className={style["back-button"]} onClick={() => props.clickBackStep(setCenter)}>
            Back
          </div> */}
          {props.hint.is_show_next ? (
            <div className={style["next-button"]} onClick={clickNextBtn}>
              Next
            </div>
          ) : null}
        </div>
      ) : null}
    </div>
  );
};

const MotionWrapper = props => {
  const [stateProps, setStateProps] = useState(props);
  const [isOpen, setIsOpen] = useState(true);

  useEffect(() => {
    setIsOpen(false);

    setTimeout(() => {
      setIsOpen(true);
      setStateProps(props);
    }, 300);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.step]);

  useEffect(() => {
    setIsOpen(true);
  }, []);
  return (
    <motion.div
      initial={{ opacity: 0, scale: 0.5 }}
      className={`${style.guideNodePageBox} ${props.hint?.class}`}
      animate={isOpen ? "open" : "closed"}
      variants={variants}
    >
      <GuideNodePage {...stateProps} />
    </motion.div>
  );
};

export default MotionWrapper;
